/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { Box, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SwitchBox from "components/SwitchBox";
import SoftTypography from "components/SoftTypography";

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const ModalContent = () => {
  const [taxPeriod, setTaxPeriod] = React.useState("month"); // | quarterly
  const [taxType, setTaxType] = React.useState("firstTime"); // | additional
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([
    { name: "checkbox1", checked: false },
    { name: "checkbox2", checked: false },
  ]);

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <>
      <Box
        sx={{
          p: 1,
          border: "1px solid black",
          borderRadius: 1,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Chọn kỳ tính thuế
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 4,
          }}
        >
          <SwitchBox
            checked={taxPeriod === "month"}
            onChange={(e) => {
              if (taxPeriod === "month") return;
              if (e.target.checked) setTaxPeriod("month");
            }}
            label="Tờ khai tháng"
          />
          <SwitchBox
            checked={taxPeriod === "arises"}
            onChange={(e) => {
              if (taxPeriod === "arises") return;
              if (e.target.checked) setTaxPeriod("arises");
            }}
            label="Tờ khai lần phát sinh"
          />
        </Box>
        {taxPeriod !== "arises" ? (
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  {taxPeriod === "quarterly" ? "Quý" : "Tháng"}
                </SoftTypography>
              </SoftBox>
              <SoftInput name={taxPeriod} type="number" defaultValue={10} />
            </Box>
            <Box sx={{ width: "100%" }}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Năm
                </SoftTypography>
              </SoftBox>
              <SoftInput name="year" type="number" />
            </Box>
          </Box>
        ) : (
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Ngày
              </SoftTypography>
            </SoftBox>
            <DatePicker
              options={{
                locale: Vietnamese,
                time_24hr: true,
                dateFormat: "d-m-Y",
              }}
              render={({ defaultValue }, ref) => (
                <SoftInput defaultValue={defaultValue} inputRef={ref} />
              )}
            />
          </Box>
        )}
        <SwitchBox
          checked={taxType === "firstTime"}
          onChange={(e) => {
            if (taxType === "firstTime") return;
            if (e.target.checked) setTaxType("firstTime");
          }}
          sx={{ mt: 2 }}
          label="Tờ khai lần đầu"
        />
        <SwitchBox
          checked={taxType === "additional"}
          onChange={(e) => {
            if (taxType === "additional") return;
            if (e.target.checked) setTaxType("additional");
          }}
          label="Tờ khai bổ sung"
        />
        {taxType === "additional" && (
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Lần
                </SoftTypography>
              </SoftBox>
              <SoftInput name="numberTime" type="number" defaultValue={1} />
            </Box>
            <Box>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Ngày lập KHBS
                </SoftTypography>
              </SoftBox>
              <DatePicker
                options={{
                  locale: Vietnamese,
                  time_24hr: true,
                  dateFormat: "d-m-Y",
                }}
                render={({ defaultValue }, ref) => (
                  <SoftInput defaultValue={defaultValue} inputRef={ref} />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default ModalContent;
